import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

/* ------------------------------------------------------------------
   全域樣式集中管理
   順序即優先權：後面載入的會蓋掉前面的。
   這裡刻意沿用整合前各頁 import 的實際載入順序，所以外觀不會改變。
   之後要調整順序或刪除不再使用的檔案，都在這一區處理。
   （元件自己的樣式，例如 function.css、machine.css、leaflet、video.js，
     仍留在各元件中，下一批再處理）
------------------------------------------------------------------ */
import "./App.css";
import "antd/dist/reset.css";
import "./themes/variables.css";
import "./themes/antd-dark-override.css";
import "./css/responsive.css";
import "./css/style-effects.css";
import "./css/button.css";
import "./pages/css/login.css";
import "./css/container.css";
import "./css/select.css";
import "./css/table.css";
import "./css/input.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/table-container.css";
import "./pages/css/control.css";
import "./pages/css/setting.css";
import UserProvider from "./global/user";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./pages/login";
import Control from "./pages/control";
import History from "./pages/history";
import Setting from "./pages/setting";
import Tutorial from "./pages/tutorial";
import PublicLiveDashboard from "./pages/PublicLiveDashboard";
import DashboardConfig from "./pages/DashboardConfig";
import DashboardView from "./pages/DashboardView";

function App() {
  return (
    <UserProvider>
      <ThemeProvider>
        <Router>
          <Switch>
            <Route path="/public/live-dashboard/:machineID">
              <PublicLiveDashboard />
            </Route>
            <Route path="/dashboard/config/:companyId">
              <DashboardConfig />
            </Route>
            <Route path="/dashboard/view/:companyId">
              <DashboardView />
            </Route>
            <Route exact path="/">
              <Login />
            </Route>
            <Route path="/control">
              <Control />
            </Route>
            <Route path="/history">
              <History />
            </Route>
            <Route path="/setting">
              <Setting />
            </Route>
            <Route path="/tutorial">
              <Tutorial/>
            </Route>
            {/* 各公司專屬登入網址 #/{slug}；必須放在最後，才不會蓋掉上面的固定路由 */}
            <Route exact path="/:slug">
              <Login />
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;